import { createStore } from 'vuex'

export default createStore({
  state: {
    company:{
      address:'',
      phone:''
    }
  },
  mutations: {
    setCompany(state, payload){
      state.company = payload
    }
  },
  actions: {
    setCompany({ commit }, payload) {
      commit("setCompany", payload);
    },
  },
  getters:{
    getCompany(state){
      return state.company
    }
  },
  modules: {
  }
})
